<ul>
  <li (click)="onDismiss('history')">Firing History</li>
  <li (click)="onDismiss('graph')">Current Graph</li>
  <li (click)="onDismiss('notes')">Notes</li>
  <li (click)="onDismiss()">Close</li>
</ul>
